import './layout.scss';

import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router';

import { AdminMobileMenu } from '@/AdminPanel/shared/features';
import { ADMIN_ROUTES, ROUTES } from '@/shared/routes';
import { MainLoader } from '@/shared/ui';
import Oops from '@/shared/widgets/errors/oops';

import { Header, MobileMenu, Navbar } from './widgets';

const Layout: React.FC = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.includes(ADMIN_ROUTES.root);

  return (
    <div className="layout">
      <Navbar />

      <div className="layout__wrapper">
        <Header />

        <main className="layout__main">
          <ErrorBoundary
            onError={console.error}
            fallback={
              <div className="layout__error">
                <Oops
                  redirect={{
                    text: 'Перейти на главную',
                    href: ROUTES.leasingScoring
                  }}
                />
              </div>
            }
          >
            <Suspense fallback={<MainLoader fullScreen={true} />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </main>

        <div className="layout__mobile-menu">
          {isAdminRoute ? <AdminMobileMenu /> : <MobileMenu />}
        </div>
      </div>
    </div>
  );
};

export default Layout;
